import ptBR from './locales/pt-BR';
import enUS from './locales/en-US';
import esES from './locales/es-ES';
import deDE from './locales/de-DE';
import itIT from './locales/it-IT';
import frFR from './locales/fr-FR';
import { detectLocale, supportedLocales, type LocaleInfo, type SupportedLocale } from './locale';
import type { TranslationKey, Translations } from './keys';

export const defaultLocale: SupportedLocale = 'en-US';
type TranslationValue = string | number | null | undefined;
type TranslationParams = Record<string, TranslationValue>;

const enGB: Translations = {
  ...enUS,
  'input.date.placeholder': 'dd/mm/yyyy',
  'input.money.placeholder': '£0.00',
  'address.zipcode.label': 'Postcode',
  'address.zipcode.placeholder': 'SW1A 1AA',
  'address.state.placeholder': 'County',
};

const dictionaries: Record<SupportedLocale, Translations> = {
  'pt-BR': ptBR,
  'en-US': enUS,
  'en-GB': enGB,
  'es-ES': esES,
  'de-DE': deDE,
  'it-IT': itIT,
  'fr-FR': frFR,
};

let currentLocale: SupportedLocale = detectLocale();

export function setLocale(locale: string) {
  currentLocale = (supportedLocales as readonly string[]).includes(locale) ? locale as SupportedLocale : defaultLocale;
  return currentLocale;
}

export function getLocale() {
  return currentLocale;
}

export function t(key: TranslationKey, params: TranslationParams = {}) {
  const template = dictionaries[currentLocale][key] || enUS[key] || key;

  return Object.entries(params).reduce(
    (message, [name, value]) => message.replaceAll(`{${name}}`, String(value ?? '')),
    template
  );
}

export function hasTranslation(key: string): key is TranslationKey {
  return key in ptBR;
}

export type { LocaleInfo, SupportedLocale, TranslationKey };
export { detectLocale, getCountryName, getLocaleInfo, resolveLocaleForCountry } from './locale';
